export const baseUrl = process.env.REACT_APP_BASE_URL;
export const appVersion = process.env.REACT_APP_VERSION;
